import * as api from 'config/axios';
import * as endpoints from './endpoints';

export const createProductOverlay = (params) => {
  return api.sendPost(endpoints.CREATE_PRODUCT_OVERLAY, params);
};

export const getProductOverlaidList = (params) => {
  return api.sendPost(endpoints.GET_PRODUCT_OVERLAID_LIST, params);
};
export const deleteProductOverlays = (params) => {
  return api.sendPost(endpoints.DELETE_PRODUCT_OVERLAYS, params);
};
export const retargetProductOverlay = (params) => {
  return api.sendPost(endpoints.RETARGET_PRODUCT_OVERLAY, params);
};

export const getAllOverlayMembers = (params) =>
  api.sendGet(endpoints.GET_ALL_OVERLAY_MEMBERS, {
    params,
  });

export const downloadBulkProductOverlay = (params) => {
  return api.sendPost(endpoints.DOWNLOAD_OVERLAYS_BULK_TEMPLATE, params);
};
